/**
 * Labstep
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import type { Group } from 'labstep-web/models/group.model';
import { User } from 'labstep-web/models/user.model';
import { mixed } from 'yup';

export const getFieldSearchSelectEntity = (
  entityName: string,
  group?: Group,
  extraParams?: Record<string, unknown>,
): FieldWithoutActionProps => ({
  fieldLabel: '',
  name: 'entity',
  fieldType: FieldType.SearchSelect,
  elementProps: {
    entityName,
    labelKey: 'displayName',
    valueKey: 'guid',
    params: {
      ...(entityName === User.entityName &&
        group && { group_id: group.guid }),
      ...extraParams,
    },
  },
  validation: mixed().required(),
});
